import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FullscreenStatus } from "@/components/layout/FullscreenStatus";
import { shouldBlockProjectNavigationForImportReview } from "@/features/story-import/review/importReviewGuard";
import { useProjectShellStore } from "@/stores/projectShellStore";

export function ProjectImportReviewGuardRoute() {
  const { t } = useTranslation();
  const { projectId } = useParams<{ projectId: string }>();
  const currentProjectId = useProjectShellStore((state) => state.currentProjectId);
  const currentProjectSummary = useProjectShellStore((state) => state.currentProjectSummary);
  const dashboardStatus = useProjectShellStore((state) => state.dashboardStatus);
  const hydrateProjectDashboard = useProjectShellStore((state) => state.hydrateProjectDashboard);

  const summary = currentProjectSummary?.projectId === projectId
    ? currentProjectSummary
    : null;

  useEffect(() => {
    if (!projectId) {
      return;
    }

    if (summary && currentProjectId === projectId) {
      return;
    }

    void hydrateProjectDashboard(projectId);
  }, [currentProjectId, hydrateProjectDashboard, projectId, summary]);

  if (!projectId) {
    return <Navigate replace to="/app" />;
  }

  if (!summary && (dashboardStatus === "idle" || dashboardStatus === "loading" || currentProjectId !== projectId)) {
    return <FullscreenStatus title={t("common.loading")} />;
  }

  if (summary?.importReviewLock && shouldBlockProjectNavigationForImportReview()) {
    return (
      <Navigate
        replace
        state={{ lockedProjectId: projectId, reviewGuardWarning: true }}
        to={summary.importReviewLock.reviewRoute}
      />
    );
  }

  return <Outlet />;
}
